import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'div[data-component-type=icon-menu]',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
